  export const getFilterPlaceholder = (filterBy) => {
    switch (filterBy) {
      case "clientName":
        return "Search by client name...";
      case "email":
        return "Search by email address...";
      case "phone":
        return "Search by phone number...";
      case "type":
        return "Search by type (Residential/Commercial)...";
      case "address":
        return "Search by address...";
      default:
        return "Search clients...";
    }
  };

  export const mapClientAreas = (clientAreas = []) => {
  if (!Array.isArray(clientAreas)) return [];
  return clientAreas.map((area) => {
    const computedAddress =
      area.address ||
      [area.city, area.state, area.zipCode, area.country].filter(Boolean).join(", ") ||
      area.name ||
      "Coverage Area";

    return {
      ...area,
      id: area.id,
      state: area.state || "",
      city: area.city || "",
      country: area.country || "",
      zipCode: area.zipCode || "",
      address: computedAddress,
      latitude: typeof area.latitude === "string" ? parseFloat(area.latitude) : (area.latitude ?? 0),
      longitude: typeof area.longitude === "string" ? parseFloat(area.longitude) : (area.longitude ?? 0),
      milesOfCoverageArea: area.milesOfCoverageArea ?? 0,
    };
  });
};